import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoopBackAuth } from '../../../assets/js/lb-sdk/services';
import { Observable } from 'rxjs';
import { USER_ROLES } from '../../enums';

@Injectable({
  providedIn: 'root'
})
export class Partners implements CanActivate {
  constructor(
    private loopBackAuth: LoopBackAuth,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return new Observable<boolean>(subscriber => {
      if (!this.getUser() || !this.getUser().roles) {
        this.router.navigate(['/401']);
        subscriber.next(false);
      } else {
        var hasAccess : boolean = this.getUser().roles.map(role => {
          if (!role || !role.role) {
            return false;
          }
          return [
            USER_ROLES.GENERAL_MERCHANT,
            USER_ROLES.DISTIBUTOR,
            USER_ROLES.NATIONAL_RETAILER,
            USER_ROLES.ONLINE_RETAILER,
            USER_ROLES.AUH,
            USER_ROLES.AUM,
            USER_ROLES.HBA,
            USER_ROLES.AIA,
            USER_ROLES.EMPLOYEE,
            USER_ROLES.BROKER,
            USER_ROLES.OTHER_SYSTEM
          ].indexOf(role.role.code) >= 0;
        }).indexOf(true) >= 0;
        if (!hasAccess) {
          this.router.navigate(['/401']);
        }
        subscriber.next(hasAccess);
      }
      subscriber.complete();
    });
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
